import { Image } from '@capsicum/common-web';
import React from 'react';
import styled from 'styled-components';

export const ShippingFlag = ({ url }: { url: string | undefined }) => {
	return url ? (
		<S.FlagWrapper>
			<S.Flag alt="Flag" height={24} src={url} width={24} />
		</S.FlagWrapper>
	) : (
		<S.FlagPlaceholder />
	);
};

namespace S {
	export const FlagWrapper = styled.div`
		position: relative;
		width: ${({ theme }) => theme.sizing.medium};
		height: ${({ theme }) => theme.sizing.medium};
		z-index: 1;
	`;

	export const Flag = styled(Image)`
		${({ theme }) => theme.border.radius.circle};
		z-index: 1;
	`;

	export const FlagPlaceholder = styled.div`
		width: ${({ theme }) => theme.sizing.medium};
		height: ${({ theme }) => theme.sizing.medium};
		${({ theme }) => theme.border.radius.circle};
		background-color: ${({ theme }) => theme.colors.backgrounds.main.subtle};
	`;
}
